import React, { use, useCallback, useContext, useEffect, useState } from 'react';
import ReactFlow, {
  addEdge,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  Panel,
  ReactFlowProvider,
} from 'reactflow';
import Threat from './custom-nodes/Threat';
import Consequence from './custom-nodes/Consequence';
import TopEvent from './custom-nodes/TopEvent';

import 'reactflow/dist/style.css';
import './custom-nodes/overview.css';
import Hazard from './custom-nodes/Hazard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleLeft, faChevronCircleRight, faChevronLeft, faChevronRight, faClose, faFire, faPlusSquare, faSignOutAlt, faWarning } from '@fortawesome/free-solid-svg-icons';
import { m, motion } from 'framer-motion'
import PBarrier from './custom-nodes/PBarrier';
import MBarrier from './custom-nodes/MBarrier';
import { toast } from 'react-toastify';
import authService from '../../authentication';
import instance from '../../api/client';
import Loader from '../loaders/Loader';
import AppContext from '../../contexts/AppContext';
import { useNavigate } from 'react-router-dom';
import MitigationEffectRadio from '../MitigationEffectRadio';
import MitigationModalContent from '../MitigationModalContent';
import MitigationModal from '../MitigationModal';
import { node } from 'prop-types';
import TakeSnapshot from '../TakeSnapshot';
// import { payloadSearcher } from 'recharts/types/chart/SunburstChart';

const nodeTypes = {
  threat: Threat,
  consequence: Consequence,
  topEvent: TopEvent,
  hazard: Hazard,
  pBarrier: PBarrier,
  mBarrier: MBarrier,
};


const minimapStyle = {
  height: 120,
};

const onInit = (reactFlowInstance) => console.log('flow loaded:', reactFlowInstance);

const cloneObject = (object) => {
  let newObj = JSON.stringify(object)
  newObj = JSON.parse(newObj)
  return newObj
}

const BowtieDiagram = ({ initialNodes, initialEdges, state, nodesMap, edgesMap, setNodesMap, setEdgesMap }) => {
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showMBarrierModal, setShowMBarrierModal] = useState(false);
 
  const [placeThreatTop, setPlaceThreatTop] = useState(true);
  const [nodeCounts, setNodeCounts] = useState({ threat: 0, consequence: 0, pBarrier: {}, mBarrier: {} });
  const [prioritization, setPrioritization] = useState({});
  const [selectedImpact, setSelectedImpact] = useState('');
  const [selectedMBarrier, setSelectedMBarrier] = useState({});
  const [barrierText, setBarrierText] = useState('');
  const [pIndex, setpIndex] = useState(0);
  const [majorNodeIndex, setMajorNodeIndex] = useState({ threat: null, consequence: null });
  const [majorNodePosition, setMajorNodePosition] = useState({ threat: null, consequence: null });
  const [placeConsequenceTop, setPlaceConsequenceTop] = useState(true);
  const navigate = useNavigate();
  const { openModal } = useContext(AppContext);
  const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), []);


  const pModel = state?.project;
  console.log(state);
  useEffect(() => {
    const impacts = initialNodes.filter((n) => n.type == 'consequence')
    console.log("impacts:", impacts);
    const p = {}
    impacts.forEach((impact) => {
      p[impact._id] = { impactId: impact._id, impactName: impact.data.text, criteria_score: impact.prioritizationModel?.criteria_score }
    })
    setPrioritization(p)
  }, [])

  // useEffect(() => {
  //   console.log("Selected mBarrier changed:", selectedMBarrier);
  // }, [selectedMBarrier])


  useEffect(() => {
    const counts = { threat: 0, consequence: 0, pBarrier: {}, mBarrier: {} };
    nodesMap.forEach((node) => {
      if (node.type in counts && typeof counts[node.type] === 'number') {
            counts[node.type]++;
      } else if (node.type === 'pBarrier' || node.type === 'mBarrier') {
            const majorNodeId = node.data?.nfor;
            counts[node.type][majorNodeId] = (counts[node.type][majorNodeId] || 0) + 1;
      }
      console.log("counting node type:", node.type, "current counts:", counts);
      setNodeCounts(counts);
    })
  },[])

  useEffect(() => {
    setNodes(initialNodes);
  }, [initialNodes]);

  useEffect(() => {
      setEdges(initialEdges);
  }, [initialEdges]);

  useEffect(() => { 
    if (selectedMBarrier._id) {
      const mBarrier = nodes.find((n) => n._id === selectedMBarrier._id);

      setBarrierText(mBarrier.data.text);
      if (mBarrier?.mbarrierEffectEntries && mBarrier.mbarrierEffectEntries.length>0) {
        const newCheckedState = {};
        const newRadioState = {};
        mBarrier.mbarrierEffectEntries.forEach((eff) => {
          const schemaIdx = pModel?.schema.findIndex((s) => s.criteria === eff.criteriaName);
          if (schemaIdx !== -1) { 
            newCheckedState[schemaIdx] = true;
            newRadioState[`effectiveness-${schemaIdx}`] = eff.levelOfImpact;
            newRadioState[`confidence-${schemaIdx}`] = eff.confidence;
          }
        });
      
        setCheckedState(newCheckedState);
        setRadioState(newRadioState);
      } else {
        setCheckedState({});
        setRadioState({});
      }
      setErrors({});
      setCurrentPage(0);
    }
  }, [selectedMBarrier._id, nodes]);


  useEffect(() => {
      if (!state.diagram.diagramId) return;
    // http://localhost:8000
    // https://rafcegh-api1.onrender.com
    // https://api.rafce.com
      
      const sse = new EventSource(`https://api.rafce.com/api/v1/sse/get-nodeUpdates/${state.diagram.diagramId}`);
      function getRealtimeData(data) {
        const collectionToType = {
          consequences: 'consequence',
          threats: 'threat',
          hazards: 'hazard', 
          pBarrier: 'pBarrier',
          mBarrier: 'mBarrier',
       };

        const type = collectionToType[data.collection]; 

        console.log("update received: ", data);
        switch (data.operationType) {
          case "insert":
            setNodesMap(prev => {
              const newMap = new Map(prev);
              newMap.set(data.changedNode.id, data.changedNode);
              return newMap;})

            if (data.newEdge) {
                setEdgesMap(prevEdges => {
                  const newEdgesMap = new Map(prevEdges);
                  newEdgesMap.set(data.newEdge.id, data.newEdge);
                  return newEdgesMap;
                })}
            setNodeCounts(prev => {
                const isMinorNode = type === "pBarrier" || type === "mBarrier";
                return {
                    ...prev,
                    [type]: isMinorNode
                        ? {
                            ...prev[type],
                            [data.changedNode.data.nfor]: (prev[type]?.[data.changedNode.data.nfor] || 0) + 1
                          }
                        : prev[type] + 1
                };
            });
            break;

            case "delete":
              setNodesMap(prev => {
                const newMap = new Map(prev);
                data.deletedNodeIds.forEach(id => newMap.delete(id));
                if (data.childIndex !== null && data.position !== null){
                  majorNodeIndex[type] = data.childIndex
                  setMajorNodeIndex({...majorNodeIndex})
                  majorNodePosition[type] = data.position
                  setMajorNodePosition({...majorNodePosition})
                } 
                if (data.updatedNodes) {
                  data.updatedNodes.forEach(({id, childIndex, position}) => {
                    const node = newMap.get(id);
                    if (node) {
                      newMap.set(id, { 
                        ...node, 
                        childIndex: childIndex,
                        position: position
                      });
                    }
                  })
                }
                return newMap;
               });
                
              setEdgesMap(prev => {
                const newMap = new Map(prev);
                newMap.delete(data.deletedEdgeId);
                if(data.newEdge){
                  newMap.set(data.newEdge.id, data.newEdge);
                }
                return newMap;
              })
              
              setNodeCounts(prev =>  {
                const isMinorNode = type === "pBarrier" || type === "mBarrier";
                return {
                    ...prev,
                    [type]: isMinorNode
                        ? {
                            ...prev[type],
                            [data.parentNodeId]: (prev[type]?.[data.parentNodeId] || 0) - 1
                          }
                        : prev[type] - 1
                    };
                  });
              break;
              case "update":
                setNodesMap(prev => {
                  const newMap = new Map(prev);
                  const node = newMap.get(data.nodeId);
                  if (node) {
                     newMap.set(data.nodeId, {
                      ...node,
                      ...(data.model !== undefined && data.model !==null && { prioritizationModel: data.model }),
                      data: {
                        ...node.data,
                        ...(data.updatedText !== undefined && data.updatedText !== null && { text: data.updatedText }),
                        lockedByUsername: data.lockedByUsername,
                      }
                    });
                    console.log(node)
                  }
                  
                  return newMap;
                })
                break;
              case "update-mitigation":
                setNodesMap(prev => {
                  const newMap = new Map(prev);
                  const node = newMap.get(data.nodeId);
                  if (node) {
                      newMap.set(data.nodeId, {
                      ...node,
                      mbarrierEffectEntries: data.effects
                    });
                  }
                  return newMap;
                })
                break;
              }

          toast(`...diagram updates received`, {
          position: toast.POSITION.TOP_CENTER, autoClose: 1500
        });
      }
     
      sse.onmessage = e => {
        setLoading(true)
        getRealtimeData(JSON.parse(e.data))
        // console.log(JSON.parse(e.data.nodeRequests));
        setLoading(false)
      };
      sse.onerror = (e) => {
        // error log here 
        console.log(e);
        sse.close();
      }
      return () => {
        sse.close();
      };
    }, [!state.diagram.diagramId]);

  const acquireLock = async (node) => {
    setLoading(true)
    try {
      const { data, status } = await instance.post(`/lock/acquire-lock/${state.diagram.projectCode}/${node.id}/${node.type}/${state.diagram.diagramId}`, {}, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        toast.success(`Lock acquired: You may edit`, {
          position: toast.POSITION.TOP_CENTER, autoClose: 1000
        });
        setLoading(false)
        return status
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER, autoClose: 1000
        });
        setLoading(false)
        return status
      }
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER, autoClose: 1000
      });
      setLoading(false)
      return error
    }
  }

  const createNode = async (payload) => {
    setLoading(true)
    try {
      const { data, status } = await instance.post(`/bowtie/create-element/${state.diagram.projectCode}/${state.diagram.diagramId}`, payload, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        toast.success(`Node added`, {
          position: toast.POSITION.TOP_CENTER, autoClose: 1000
        });

        setLoading(false)
        return status
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER, autoClose: 1000
        });
        setLoading(false)
        return status
      }
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER, autoClose: 1000
      });
      setLoading(false)
      return error
    }
  }

  const deleteNode = async (payload) => {
    setLoading(true)
    try {
      const { data, status } = await instance.post(`/bowtie/delete-element/${state.diagram.projectCode}/${state.diagram.diagramId}`, payload, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        toast.success(`Node deleted`, {
          position: toast.POSITION.TOP_CENTER, autoClose: 1000
        });

        setLoading(false)
        return status
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER, autoClose: 1000
        });
        setLoading(false)
        return status
      }
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER, autoClose: 1000
      });
      setLoading(false)
      return error
    }
  }

  const updateNode = async (id, type, projectCode, diagramId, text) => {
    setLoading(true)
    try {
      const { data, status } = await instance.put(`/bowtie/update-element/${id}/${type}/${projectCode}/${diagramId}`, {
        text
      }, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        toast.success(`Saved`, {
          position: toast.POSITION.TOP_CENTER, autoClose: 1000
        });

        setLoading(false)
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER, autoClose: 1000
        });
        setLoading(false)
      }
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER, autoClose: 1000
      });
      setLoading(false)
    }
  }

  const getMinorNodePositionForAdding = (baseNode, minorNodeWidth, majorNodeWidth, type, spacing, index) => {
    const baseX = baseNode.position.x;
    const baseY = baseNode.position.y;

    let x;
    let fromMajorNode;
    switch(type){
      case "pBarrier":
        fromMajorNode = baseX - minorNodeWidth + majorNodeWidth/4 - spacing;
        break;
      case "mBarrier":
        fromMajorNode = baseX + majorNodeWidth;
        break;
      default:  
        throw new Error("Invalid node type");
    }

    if (index === 0){
      x = (type === "mBarrier") 
              ? fromMajorNode + spacing : 
              fromMajorNode  - spacing;

    } else {
      const gap = (index * minorNodeWidth) + (index+1) * spacing;
      x = (type === "mBarrier")
              ? fromMajorNode + gap 
              : fromMajorNode - gap;
    }
    return{x:x, y:baseY}
  }

  const addPBarrier = async (threatId) => {
    // const getNodeById = (nodeId) => nodes.find((n) => n.id === nodeId);
    const GAP = 70;
    const norm = (v) => String(v);
    const relatedRaw = getRelatedNodes(threatId) || [];
    const baseNode = cloneObject(relatedRaw.find((n) => norm(n.id) === norm(threatId)));
    
    const newIndex = nodeCounts.pBarrier[threatId] || 0;
  
    const lastChildId = newIndex > 0 
                      ? relatedRaw.find((n) => n.type === "pBarrier" && n.childIndex === newIndex - 1 )?.id
                      : threatId;

    console.log("Base node", baseNode)
    const position = getMinorNodePositionForAdding(baseNode, 160, 220, "pBarrier", GAP, newIndex);
    const newID = getNewId();
    const newNode = [{
      id: newID,
      type: 'pBarrier',
      diagramId: state.diagram.diagramId,
      position: position,
      majorNodeId: baseNode?._id ,
      childIndex: newIndex,
      data: {
        nfor: threatId,
        handles: {
          'handle-left': 'smoothstep',
          'handle-right': 'smoothstep',
        },
        lockedByUsername: null
      },
    }]

    const newEdge = {
      id: `${newIndex === 0 ? `e${newID}-${threatId}` : `e${newID}-${lastChildId}`}`,
      source: newID,
      target: (newIndex === 0 ? threatId : lastChildId),
      type: 'smoothstep',
      sourceHandle: 'handle-right',
      targetHandle: 'handle-left',
      data: { selectIndex: 1 },
    }
    
    const newEdgeList = [...edges, newEdge];
    await createNode({
      nodeRequests: newNode,
      edges: newEdgeList,
      newEdge: newEdge, 
      childIndex: newIndex,
    });
  }

 const addMBarrier = async (impactId) => {
    // const getNodeById = (nodeId) => nodes.find((n) => n.id === nodeId);
    const GAP = 70;
    const norm = (v) => String(v);
    const relatedRaw = getRelatedNodes(impactId) || [];
    const baseNode = cloneObject(relatedRaw.find((n) => norm(n.id) === norm(impactId)));
    const newIndex = nodeCounts.mBarrier[impactId] || 0;

    const lastChildId = newIndex > 0 
                      ? relatedRaw.find((n) => n.type === "mBarrier" && n.childIndex === newIndex - 1 )?.id
                      : impactId;


    const position = getMinorNodePositionForAdding(baseNode, 160, 220, "mBarrier", GAP, newIndex);
    const newID = getNewId();
    const newNode = [{
      id: newID,
      type: 'mBarrier',
      diagramId: state.diagram.diagramId,
      position: position,
      majorNodeId: baseNode?._id ,
      childIndex: newIndex,
      data: {
        nfor: impactId,
        handles: {
          'handle-left': 'smoothstep',
          'handle-right': 'smoothstep',
        },
        lockedByUsername: null
      },
    }]

    const newEdge = {
      id: `${newIndex === 0 ? `e${newID}-${impactId}` : `e${newID}-${lastChildId}`}`,
      source: newID,
      target: (newIndex === 0 ? impactId : lastChildId),
      type: 'smoothstep',
      sourceHandle: 'handle-right',
      targetHandle: 'handle-left',
      data: { selectIndex: 1 },
    }
    
    const newEdgeList = [...edges, newEdge];
    await createNode({
      nodeRequests: newNode,
      edges: newEdgeList,
      newEdge: newEdge, 
      childIndex: newIndex,
    });
    console.log("Barrier for nfor counts:", nodeCounts.mBarrier[baseNode?.id])
  }


  // all get functions here require a major node (threat or consequence) ID parameter not a minor node (barrier)
  const getRelatedNodes = (id) => {
    return nodes.filter((node) => {
      if (node.id === id) {
        return true
      } else if (node.data?.nfor === id) {
        return true
      } else {
        return false
      }
    })
  }

  const getUnRelatedNodes = (id) => {
    return nodes.filter((node) => {
      if (node.id === id) {
        return false
      } else if (node.data?.nfor === id) {
        return false
      } else {
        return true
      }
    })
  }

  const getRelatedEdges = (id) => {
    const relatedNodeIds = getRelatedNodes(id).map((n) => n.id)
    return edges.filter((edge) => {
      if (relatedNodeIds.includes(edge.target) || relatedNodeIds.includes(edge.source)) {
        return true
      } else {
        return false
      }
    })
  }

  const getUnRelatedEdges = (id) => {
    const relatedNodeIds = getRelatedNodes(id).map((n) => n.id)
    return edges.filter((edge) => {
      if (relatedNodeIds.includes(edge.target) || relatedNodeIds.includes(edge.source)) {
        return false
      } else {
        return true
      }
    })
  }

  const deleteBarrier = async (id, nfor) => {
    await deleteNode(
      { 
        id: id, 
        type: nodes.find((node) => node.id == id).type,
        majorNodeId: nfor,
        nodeWidth : 160,
        gap: 70,
      })
  }

  const deleteMajorNode = async (id) => {
    //delete threat or consequence
   await deleteNode(
      { 
        id: id, 
        type: nodes.find((node) => node.id == id).type
      })
      
    console.log("NodeCounts: ", nodeCounts.consequence)
  }

  // we are using a bit of a shortcut here to adjust the edge type
  // this could also be done with a custom edge for example
 const edgesWithUpdatedTypes = edges.map((edge) => {
    if (edge.sourceHandle) {
      const edgeType = nodes.find((node) => (node.type === 'threat') || (node.type === 'consequence'))
        ?.data.handles[edge.sourceHandle];
      edge.type = undefined;
    }

    return edge;
  });

  const getNewId = () => {
    const ids = nodes.map((node) => parseInt(node.id))
    const newID = `${Math.max(...ids) + 1}`
    return newID
  }


  const getPosition = (index, nodeType, spacing) => {
      let baseX;
      let baseY;
      switch(nodeType){
        case "threat":
          baseX = -360;
          baseY = 200;
          break;
        case "impact":
          baseX = 360;
          baseY = 200;
          break;
        case "topEvent":
          baseX = 0;
          baseY = 200;
          break;
        case "hazard":
          baseX = 0;
          baseY = -20;
          break;
        default:
          throw new Error("Invalid node type");
       }

          let y;
          if(index === 0){
            y = baseY;
          }else{
            const isEven = index % 2 === 0;
            const multiplier = Math.floor((index + 1) / 2);
            y = (nodeType === "threat" || nodeType === "impact") 
            ? baseY + (isEven ? 1 : -1) * multiplier * spacing
            : baseY
          }
          return { x: baseX, y: y };
  }
  

  const addThreat = async (e) => {
    const newIndex = nodeCounts.threat;
    const position = getPosition(newIndex, "threat", 150);
    const newID = getNewId();

    console.log("NodeCounts: ", newIndex)
    const newNode = [{
      id: (newIndex === 0 ? '1' : newID),
      type: 'threat',
      diagramId: state.diagram.diagramId,
      position: position,
      data: {
        handles: {
          'handle-1': 'smoothstep',
          'handle-left': 'smoothstep',
        },
        lockedByUsername: null
      },
    }]

    const newEdge = {
        id: (newIndex === 0 ? 'e1-3' : `e${newID}-3`),
        source: (newIndex === 0 ? '1' : newID),
        target: '3',
        type: 'smoothstep',
        sourceHandle: 'handle-1',
        targetHandle: 'handle-left',
        data: {}
    }

    await createNode({
        nodeRequests: newNode,
        edges: [...edges, newEdge],
        newEdge: newEdge,
        childIndex: newIndex,
    })
  }

  const addConsequence = async (type, ) => {
    const newIndex  = majorNodeIndex.consequence == null ? nodeCounts.consequence: majorNodeIndex.consequence;
    const position = getPosition(newIndex, "impact", 150);
    const newID = getNewId()

    console.log("NodeCounts: ", newIndex)
    const newNode = [{
      id: (newIndex === 0 ? '2' : newID),
      type: 'consequence',
      diagramId: state.diagram.diagramId,
      position: majorNodePosition.consequence !== null ? majorNodePosition.consequence : position,
      childIndex: newIndex,
      data: {
        handles: {
          'handle-2': 'smoothstep',
          'handle-right': 'smoothstep',
        },
        lockedByUsername: null
      },
    }]

    const newEdge = {
        id: (newIndex === 0 ? 'e2-3' : `e${newID}-3`),
        source: (newIndex === 0 ? '2' : newID),
        target: '3',
        type: 'smoothstep',
        sourceHandle: 'handle-2',
        targetHandle: 'handle-right',
        data: {}
    }

    await createNode({
        nodeRequests: newNode,
        edges: [...edges, newEdge],
        newEdge: newEdge,
        childIndex: newIndex,
    })
    majorNodeIndex[type] = 0
    setMajorNodeIndex(prev => ({...prev, consequence: null}))
    setMajorNodePosition(prev => ({...prev, consequence: null}))
  }


  const getProgress = () => {
    let progress = 0
    let num = pModel.schema.length
    pModel.schema.forEach((s) => {
      if (prioritization[selectedImpact].criteria_score[s.criteria] || prioritization[selectedImpact].criteria_score[s.criteria] === 0) {
        progress++;
      }
    })
    return progress * 100 / num
  }

  const nodesWithData = nodes.map((node) => {
    // Create a new object for node.data to avoid direct mutation
    const newData = {
      ...node.data,
      prioritized: node.prioritizationModel?.criteria_score &&
        Object.keys(node.prioritizationModel?.criteria_score).length === pModel?.schema.length,
      disabled: !(node.data?.text || '').trim(),
      computedEffect: node.mbarrierEffectEntries && node.mbarrierEffectEntries.length > 0, 
      update: (text) => updateNode(node.id, node.type, state.diagram.projectCode, state.diagram.diagramId, text),
      acquireLock: async () => await acquireLock(node),
      rank: node.prioritizationModel?.individualRank
    };
  
    // Apply conditionally based on the type of node
    if (node.type === 'threat') {
      newData.delete = !loading ? deleteMajorNode : () => {};
      newData.addBarrier = !loading ? addPBarrier : () => {};
    } else if (node.type === 'consequence') {
      if (!prioritization[node._id]?.criteria_score) {
        let p = cloneObject(prioritization);
        p[node._id] = { impactId: node._id, criteria_score: {} };
        setPrioritization(p);
      }
      newData.showModal = !loading ? () => { setSelectedImpact(node._id); setShowModal(true); } : () => {};
      newData.delete = !loading ? deleteMajorNode : () => {};
      newData.addBarrier = !loading ? addMBarrier : () => {};
    } else if (node.type === 'mBarrier') {
      newData.showMBarrierModal = !loading ? () => { setSelectedMBarrier({_id: node._id, impactID: node.impactID});   setShowMBarrierModal(true); } : () => {};
      newData.delete = !loading ? deleteBarrier : () => {};
    } else if (node.type === 'pBarrier') {
      newData.delete = !loading ? deleteBarrier : () => {};
    } else if (node.type === 'topEvent') {
      newData.addThreat = !loading ? addThreat : () => {};
      newData.addConsequence = !loading ? addConsequence : () => {};
    }
  
    // Return a new object for the node without mutating the original
    return {
      ...node,
      draggable: false,
      data: newData,
    };
  });
  

  const submitPrioritizationHandler = async () => {
    try {
      setLoading(true)
      const { data, status } = await instance.post('/prioritize/compute-impact-score', prioritization[selectedImpact], {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        toast.success("Submission recorded", {
          position: toast.POSITION.TOP_CENTER
        });
        setShowModal(false)
      } else {
        toast.error("Submssion Failed", {
          position: toast.POSITION.TOP_CENTER
        });
      }
    } catch (error) {
      toast.error(error, {
        position: toast.POSITION.TOP_CENTER
      });
    }
    setLoading(false)
  };

    // START OF MITIGATION BARRIER STUFF
  const ITEMS_PER_PAGE = 3;
  const [currentPage, setCurrentPage] = useState(0);
  const [checkedState, setCheckedState] = useState({});
  const [radioState, setRadioState] = useState({});

  const [errors, setErrors] = useState({});
  const startIndex = currentPage * ITEMS_PER_PAGE;
  const currentItems = pModel?.schema.slice(
        startIndex,
        startIndex + ITEMS_PER_PAGE
    );

  const validatePage = () => {    
        const newErrors = {}
        currentItems.forEach((s, index) => {
            const globalIndex = startIndex + index;
            if (checkedState[globalIndex]) {
                const eff = radioState[`effectiveness-${globalIndex}`];
                const conf = radioState[`confidence-${globalIndex}`];
                if (!eff || !conf){
                    newErrors[globalIndex] = 'Please select both effectiveness and confidence.'      
                }
            }}
        )
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

  const submitMitigationEffectHandler = async () => {
        console.log("selected mbarrier", selectedMBarrier._id)
                console.log("selected mbarrier impactID", selectedMBarrier.impactID)
                // setSelectedMBarrier(null);
    if (!validatePage()) return;
        try {
            setLoading(true)
            const effect = [];
            Object.keys(checkedState).forEach(key => {
              if(checkedState[key]){
                  const index = Number(key)
                  const criteriaName = pModel.schema[index].criteria;
                  const level = radioState[`effectiveness-${index}`];
                  const confidence = radioState[`confidence-${index}`];
                  if (criteriaName && level && confidence) {
                      effect.push({
                          criteriaName: criteriaName,
                          levelOfImpact: level,
                          confidence: confidence,
                      })}
                  
              }})
            
            const { data, status } = await instance.post(`/bowtie/update-mBarrier/${selectedMBarrier._id}/${selectedMBarrier.impactID}/${state.diagram.diagramId}`, effect, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            if (status == 200) {
                toast.success("Submission recorded", {
                position: toast.POSITION.TOP_CENTER
                });
                
                setShowMBarrierModal(false);

            } else {
                toast.error("Submission Failed", {
                position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)
    };

  // END OF MITIGATION BARRIER STUFF

  
  

  return (
    <ReactFlowProvider>
      {
        loading &&
        <div className=' absolute top-5 left-5 items-center justify-center'>
          <Loader animationName={'loader'} height={100} width={100} />
        </div>
      }
      {
        showMBarrierModal && 
       <MitigationModal 
          barrierName={barrierText}
          setShowMBarrierModal={setShowMBarrierModal}
          pModel={pModel} 
          ITEMS_PER_PAGE={ITEMS_PER_PAGE} 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          currentItems={currentItems}
          startIndex={startIndex}
          checkedState={checkedState}
          setCheckedState={setCheckedState}
          errors={errors}
          radioState={radioState}
          setRadioState={setRadioState}
          validatePage={validatePage}
          submitMitigationEffectHandler={submitMitigationEffectHandler}/>
      }

      {
        showModal &&
        <div style={{ fontFamily: 'MavenPro' }} className='absolute bg-black/30 z-[9999] w-full h-full flex justify-center items-center'>
          <div className=' flex-col justify-center items-center'>
            <div className='bg-gray-100/90 w-[600px] shadow-md rounded-xl border border-2 border-gray-300 p-10 pb-5'>
              <div className='flex justify-end text-black'><FontAwesomeIcon className='cursor-pointer' onClick={() => {
                setShowModal(false);
              }} icon={faClose} size='xl' /></div>
              <div className='text-xl uppercase text-gray-800 text-center font-semibold '>Prioritization</div>
              <div className='w-32 h-[2px] bg-gray-500 mx-auto mb-10 mt-1' />
              <div className='mx-5'>

                <div className='font-semibold text-3xl mb-1 text-fuchsia-900/80'>{pModel?.schema[pIndex]?.criteria}</div>
                <div className='text-gray-500 font-semibold text-md ml-4 mt-2'>{pModel?.schema[pIndex]?.description}</div>
                <div className='w-full h-[2px] bg-gray-400 mx-auto mt-5' />

                <div className='font-semibold text-xl mt-5 flex justify-center items-center'>Select an impact factor</div>
              </div>
              <div className='w-2/3 mx-auto mt-5 mb-5 overflow-y-scroll h-[200px]'>
                {(pModel.schema[pIndex]?.factors).map((factor) => (
                  <div
                    onClick={() => {
                      let p = { ...prioritization }
                      const criteriaList = pModel?.schema[pIndex]
                      const criteriaName = criteriaList?.criteria
                      p[selectedImpact].criteria_score[criteriaName] = factor.score
                      setPrioritization(p)
                      setpIndex((pIndex + 1) % pModel?.schema.length)
                    }}
                    className={`w-full transition-all ease-linear duration-[150ms] cursor-pointer border border-y-2 border-gray-300 ${(prioritization[selectedImpact].criteria_score[pModel?.schema[pIndex]?.criteria] == factor.score) ? 'bg-teal-900/80 text-white rounded-xl text-lg' : ''
                      } hover:bg-teal-900/50 hover:text-white hover:text-lg p-3`}>{factor.name}{`${factor.description?': '+factor.description:''}`}</div>
                ))}
              </div>
              <div className={`flex items-center justify-center transition-all ease-linear duration-300 mb-5 px-14 overflow-hidden ${getProgress() == 100 ? 'w-full' : 'w-[0px] h-[0px]'}`}>
                <div className='w-full border border-2 border-teal-800/50 text-teal-800 cursor-pointer font-semibold p-2 hover:bg-gray-100 uppercase flex items-center justify-center rounded-3xl text-lg' onClick={submitPrioritizationHandler}>
                  Submit
                </div>
              </div>
              <div className='w-full rounded overflow-hidden px-14'>
                <div style={{ width: `${getProgress()}%` }} className={`h-4 transition-all ease-linear duration-300 ${getProgress() == 100 ? 'bg-green-600' : 'bg-red-600'}`} />
              </div>
              <div className='w-full h-[2px] bg-gray-400 mx-auto mt-5' />
              <div className='flex justify-end mt-5'>
                <div onClick={() => { setpIndex((pIndex - 1) < 0 ? pModel?.schema.length - 1 : pIndex - 1) }} className='rounded flex justify-center items-center w-1/2 h-8 cursor-pointer hover:text-white hover:bg-gray-600'><FontAwesomeIcon icon={faChevronLeft} size='lg' /></div>
                <div onClick={() => { setpIndex((pIndex + 1) % pModel?.schema.length) }} className='rounded flex cursor-pointer justify-center items-center w-1/2 h-8 hover:text-white hover:bg-gray-600'><FontAwesomeIcon icon={faChevronRight} size='lg' /></div>
              </div>
            </div>
          </div>
        </div>
      }
      <div className='absolute z-[9998] top-4 left-1/2 -translate-x-1/2 flex py-2 px-5 gap-2 bg-slate-200 w-3/4 items-center justify-between rounded-lg'>
        <span>{state.project.name}</span>
        <div className='flex justify-evenly items-center gap-4'>
          <div onClick={() => {
              openModal("Exit?",
                `Make sure everything is saved before you exit. Are you sure you want to exit? `,
                () => { navigate(-1) }
              )
            }} className='hover:scale-110 px-5 py-1 cursor-pointer border border-red-700 hover:border-red-800 shadow-lg text-white hover:bg-red-800 duration-200 rounded-lg bg-red-700 text-black spacing-2'>
            <FontAwesomeIcon icon={faSignOutAlt} /> Exit
          </div>
          <TakeSnapshot text = 'Download' diagramName={state.diagram.diagramName}/>
        </div>
      </div>
      <ReactFlow
        nodes={nodesWithData}
        edges={edgesWithUpdatedTypes}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onInit={onInit}
        fitView
        attributionPosition="top-right"
        nodeTypes={nodeTypes}
      >
        <MiniMap style={minimapStyle} zoomable pannable />
        <Controls />
        {/* <Panel position="top-left">
          <TakeSnapshot />
        </Panel> */}
        <Background color="#aaa" gap={16} />
      </ReactFlow>
    </ReactFlowProvider>
  );
}

export default BowtieDiagram;